import { render } from "./OrganisationGoodieAdd.vue?vue&type=template&id=1d10af1e"
import script from "./OrganisationGoodieAdd.vue?vue&type=script&lang=js"
export * from "./OrganisationGoodieAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__